import React from "react";
import "../css/styleEspaciosDeportivos.css";

// Chip de estado de la reserva según "stado"
const chipEstado = (stado) => {
  if (+stado === 1) {
    return (
      <span className="esen-chip esen-chip--success">
        <i className="fa fa-thumbs-up" aria-hidden="true"></i> Aprobada
      </span>
    );
  }
  if (+stado === 2) {
    return (
      <span className="esen-chip esen-chip--neutral">
        <i className="fa fa-hand-paper-o" aria-hidden="true"></i> Cancelada por ti
      </span>
    );
  }
  if (+stado === 3) {
    return (
      <span className="esen-chip esen-chip--danger">
        <i className="fa fa-thumbs-down" aria-hidden="true"></i> Cancelada por administración
      </span>
    );
  }
  return (
    <span className="esen-chip esen-chip--warning">
      <i className="fa fa-clock-o" aria-hidden="true"></i> En espera de aprobación
    </span>
  );
};

const CarCanchas = ({ reservasData, fecha, espacio, Horas, spacios_libres, spacios_reservados, _id, btnCancelarReserva }) => {
  return reservasData.map((reservas, key) => {
    return (
      <div key={"eerr" + key} className="card-body">
        <div className="table-responsive">
          <table key={"tableReserva" + key} className="table">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Espacio</th>
                <th scope="col">Horas</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr key={key}>
                <td>{fecha}</td>
                <td>
                  {espacio}
                  {reservas.espacio ? (
                    <span className="d-block text-muted">
                      ({reservas.espacio})
                    </span>
                  ) : null}
                </td>
                <td>
                  {Horas.horas[reservas.hora_inicio]} /{" "}
                  {Horas.horas[reservas.hora_fin]}
                </td>
                <td>{chipEstado(reservas.stado)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {reservas.participantes ? (
          <>
            <p className="mb-2">
              <b>Participantes / Integrantes</b>
            </p>
            <div className="table-responsive">
              <table className="table table-sm">
                <tbody>
                  {reservas.participantes.map((ele, key) => {
                    return (
                      <tr key={"ttaas" + key}>
                        <td>
                          <span className="mr-3">{key + 1}</span>
                        </td>
                        <td>
                          <span className="mr-3">{ele.carnet}</span> {ele.nombre}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : null}

        {+reservas.stado === 2 || +reservas.stado === 3 ? (
          <p className="text-center mb-0">
            <span className="esen-chip esen-chip--neutral">
              <i className="fa fa-ban" aria-hidden="true"></i> Reserva cancelada
            </span>
          </p>
        ) : (
          <div className="col-12 mt-4">
            <button
              type="button"
              className="btn btn-outline-danger btn-block"
              data-inicio={reservas.hora_inicio}
              data-fin={reservas.hora_fin}
              data-carnet={reservas.responsable}
              data-libres={JSON.stringify(spacios_libres)}
              data-reservados={JSON.stringify(spacios_reservados)}
              data-id={_id}
              data-iid={reservas.responsable + _id + reservas.hora_inicio + reservas.hora_fin}
              onClick={btnCancelarReserva}
              id={reservas.responsable + _id + reservas.hora_inicio + reservas.hora_fin}
            >
              <i className="fa fa-trash-o mr-2" aria-hidden="true"></i>
              Cancelar reserva
            </button>
          </div>
        )}
      </div>
    );
  });
};

export default CarCanchas;
